import './App.css';
import StaticTable from './components/StaticTable';
import DynamicTable from './components/DynamicTable';
import { useEffect, useState } from 'react';

function App() {
  const [dateTime, setDateTime] = useState('')
  const updatedTime = (date) => {
    setDateTime(date)
  }
  return (
   <div className="App">
  <div className="page-shell">
    <header className="app-header">
      <div className="app-header-govt">
        <img src="/govt-logo.svg" alt="Government of Punjab" className="govt-logo" />
      </div>
      <div className="app-header-title">
        <h1>DIRECTOR'S DASHBOARD</h1>
        <span className='sub-heading'>Government of Punjab</span>
      </div>
      <div className="app-header-date">
        <span>Last Updated : {dateTime ?? 'dd-mm-yyyy'}</span>
      </div>
    </header>
    <StaticTable updatedTime={updatedTime} />
    <DynamicTable />
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-center">
          <p>© {new Date().getFullYear()} Government of Punjab. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</div>
  );
}

export default App;
